import { Sparkles } from 'lucide-react';
import { VIDEO_MODELS } from '../../storyboard/common/Constants';
import { SEEDANCE25_PROVIDER_OPTIONS, getSeedance25Capabilities } from '../../../utils/seedance25Capabilities';

// Canvas-only options: leave the legacy storyboard model list and its asset paths unchanged.
export const CANVAS_VIDEO_MODELS = [
  ...VIDEO_MODELS,
  ...SEEDANCE25_PROVIDER_OPTIONS.map(({ value: provider }) => {
    const capabilities = getSeedance25Capabilities(provider);
    return {
      id: provider,
      name: capabilities.label,
      icon: Sparkles,
      accentColor: '#14b8a6',
      desc: capabilities.referenceNotice || '参考素材须进入对应官方素材库',
      defaultDuration: `${capabilities.defaultDuration}s`,
      defaultSubModel: capabilities.model,
      subModels: [{
        id: capabilities.model,
        name: capabilities.label,
        durationRange: [capabilities.minDuration, capabilities.maxDuration],
        defaultDuration: capabilities.defaultDuration,
        resolutions: capabilities.resolutions,
        defaultResolution: capabilities.resolutions[0],
      }],
    };
  }),
];
